import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCreationCollectives } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { creationClubsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfCreativeCircleContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const creationClubs = useAppSelector(creationClubsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().creationClubs });

  const hasData = creationClubs.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(creationClubs, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Творческие коллективы" Icon={IconWidgetCreationCollectives}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCreativeCircleContainer;
